import classnames from "classnames";
import { navigationItemPropType } from "../../../../state/modules/navigation";
import { getBackgroundImageUrl } from "../../../../helpers/navigationBackgroundImageResolver";
import LazyImage from "../../../LazyImage";
import { BACKGROUND_LOADING_COLORS } from "../../../LazyImage/constants";

import NavAnchor from "../../NavAnchor";
import styles from "./index.css";

const cx = classnames.bind(styles);

const CircleImageLink = ({ item, ...anchorProps }) => {
  const { label, largeScreenImageUrl, largeScreenStyleType } = item;
  return (
    <li className={styles.circleImageLink}>
      <NavAnchor item={item} {...anchorProps}>
        <div className={styles.circleImageBorder}>
          <LazyImage
            aria-hidden="true"
            className={styles.circleImage}
            role="presentation"
            src={getBackgroundImageUrl(largeScreenImageUrl, 240)}
            tag={"div"}
            loadingColor={BACKGROUND_LOADING_COLORS.silverForDesktop}
          />
        </div>
        <span
          className={cx(styles.label, {
            [styles.label__sale]: largeScreenStyleType === "sale",
            [styles.label__bold]: largeScreenStyleType === "premium"
          })}
        >
          {label.substring(0, 16)}
        </span>
      </NavAnchor>
    </li>
  );
};

CircleImageLink.propTypes = {
  item: navigationItemPropType.isRequired
};

export default CircleImageLink;
